<template>
  <div
        class="
          flex
          items-center
          flex-none
          mr-180px
          <xl:mr-85px
          <lg:mr-40px
        "
      >
        <router-link to="/menu">
          <button class="hover:opacity-60">
            <img
              v-svg-inline
              class="h-40px w-40px <xl:h-30px <xl:w-30px"
              :class="{ 'fill-white': white, 'fill-black': !white }"
              src="../assets/icons/icon_menu.svg"
            />
          </button>
        </router-link>
      </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RightMenuButtonBlock',
  props: {
    white: Boolean,
  },
});
</script>

<style>
.custom-mr {
    margin-right: calc(calc(calc(calc(100vw - 1440px)/2) + 185px));
}
</style>
